export default function (telkomUser, revenuePartnerId, userAccessId) {
    return {
        msisdn: telkomUser.Msisdn,
        status: getStatus(telkomUser),
        scheme: telkomUser.Scheme,
        revenuePartnerId: revenuePartnerId,
        grantAccess: getGrantAccess(telkomUser),
        userAccessId: userAccessId,
        username: telkomUser.Username,
        optInServiceMsgs: true,
        automatedEntries: telkomUser.AutomatedEntries,
        loginPromo: false,
    }
}

function getStatus(telkomUser) {
    if (telkomUser.Status === 'ACTIVE' || telkomUser.Status === 'PENDING') return "Subscribed"
    else return "Cancelled"
}

function getGrantAccess(telkomUser) {
    return telkomUser.Status === 'ACTIVE' || telkomUser.Status === 'PENDING'
}
